export interface ICampaignHostEnterpriseSupportPayload {
    creators_needed: number;
    additional_details: string;
    name?: string;
    email?: string;
    phone?: string;
}

/** Validates and builds the POST /support/contact body. Throws on invalid input. */
export function buildCampaignHostEnterpriseSupportBody(payload: ICampaignHostEnterpriseSupportPayload) {
    const creators = Math.floor(Number(payload.creators_needed));
    if (!Number.isFinite(creators) || creators < 1) {
        throw new Error('Enter how many creators you need.');
    }
    const details = (payload.additional_details || '').trim();
    if (!details) {
        throw new Error('Please add a few details about your program.');
    }

    return {
        inquiry_type: 'campaign-host-enterprise' as const,
        subject: 'Campaign Host Enterprise inquiry',
        creators_needed: creators,
        additional_details: details,
        appName: 'thspian' as const,
        ...(payload.name?.trim() && { name: payload.name.trim() }),
        ...(payload.email?.trim() && { email: payload.email.trim() }),
        ...(payload.phone?.trim() && { phone: payload.phone.trim() }),
    };
}
